import { createMuiTheme } from '@material-ui/core/styles';

const primaryColor = 'rgb(227,68,41)';
const primaryColorHover = 'rgb(227,68,41)';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: primaryColor,
      main: primaryColor,
      dark: primaryColor,
      contrastText: "rgb(255,255,255)",
    },
    secondary: {
      light: primaryColorHover,
      main: primaryColorHover,
      dark: primaryColorHover,
      contrastText: "rgb(0,255,0)",
    },
  },
  
});

export default theme;